import script from "./ChatStructureTableCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatStructureTableCard.vue?vue&type=script&setup=true&lang=js"

import "./ChatStructureTableCard.vue?vue&type=style&index=0&id=cb1ad71c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb1ad71c"]])

export default __exports__